import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Standard from "../Standard";
import logo from "../../branding/current/logo.png";
import logoDark from "../../branding/current/logo_dark.png";

export class WrongUnamePwd extends React.Component {
  invalid = () => {
    return (
      <div className={"text-align-center margin-auto"}>
        <h1>{this.props.l10n("error.usernameorpassword")}</h1>
      </div>
    );
  };

  render() {
    const { contrast, l10n } = this.props;
    return (
      <Standard
        logo={logo}
        logoDark={logoDark}
        contrast={contrast}
        l10n={l10n}
        include={this.invalid()}
      />
    );
  }
}

WrongUnamePwd.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
});

export default connect(mapStateToProps)(WrongUnamePwd);






// WEBPACK FOOTER //
// ./src/kiosk/callStates/WrongUsernamePassword.jsx